<template>
  <div class="atividades-sacsolicitacoes ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->

        <b-col cols="3">
          <label for="select-empresa">Empresa</label>
          <multiselect
            id="selecao-empresa-sol"
            v-model="value_empresa"
            required
            :options="empresas"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            @close="loadFiliais()"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="empresa"
            track-by="empresa"
            name="empresa"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Empresa selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="3">
          <label for="select-garagem_sol">Filial</label>
          <multiselect
            id="selecao-filial-sol"
            v-model="value_filial"
            required
            :options="filiais"
            :multiple="true"
            :taggable="true"
            :close-on-select="false"
            :clear-on-select="false"
            @close="loadStatus()"
            :preserve-search="true"
            placeholder="Selecione a filial"
            label="filial"
            track-by="filial"
            name="filial"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Filial selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="2">
          <label for="select-status">Status</label>

          <multiselect
            id="selecao-status-sol"
            v-model="value_status"
            required
            :options="statuss"
            :multiple="true"
            :taggable="true"
            @close="loadSacSolicitacoes()"
            @tag="addTag"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Status"
            label="status"
            track-by="status"
            name="status"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} status selecionado</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="2" class="mb-0">
          <label for="input-busca">Pesquisa no grid </label>
          <b-form-input
            id="buscamonitoramento"
            v-model="search"
            required="required"
            placeholder="Registro ou Tipo de solicitação ou palavras na solicitação"
          ></b-form-input>
        </b-col>

        <!-- condicional para exibir o botão planilha-->
        <b-col cols="2" v-if="user.id_grupo == 13">
          <br />
          <b-button
            variant="primary"
            class="mr-2 mt-2"
            :disabled="carregando"
            @click="(carregando = true), loadPedidoFerias()"
          >
            <b-spinner v-if="carregando" small style="margin-bottom: 3px">
            </b-spinner>
            Planilha de férias
          </b-button>
        </b-col>

        <b-col cols="2" v-if="user.id_grupo == 18">
          <br />
          <b-button
            variant="primary"
            class="mr-2 mt-2"
            :disabled="carregando"
            @click="(carregando = true), loadPedidoFerias()"
          >
            <b-spinner v-if="carregando" small style="margin-bottom: 3px">
            </b-spinner>
            Planilha de férias
          </b-button>
        </b-col>

        <!--            <LoadingModal_atendimento v-if="isLoading" />   -->
      </b-row>
    </b-form>

    <b-row>
      <b-col cols="3" class="mt-3">
        <b-card
          class="ml-2"
          style="width: 33rem"
          border-variant="primary"
          header="SOLICITAÇÕES PENDENTES"
          header-bg-variant="danger"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>
              {{ itemsFiltered.filter((s) => s.status === "PENDENTE").length }}
            </h2>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col cols="3" class="mt-3">
        <b-card
          class="mr-2"
          style="width: 33rem"
          border-variant="primary"
          header="SOLICITAÇÕES EM ATENDIMENTO"
          header-bg-variant="warning"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>
              {{ itemsFiltered.filter((s) => s.status === "ANDAMENTO").length }}
            </h2>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col cols="3" class="mt-3">
        <b-card
          class="mr-2"
          style="width: 33rem"
          border-variant="primary"
          header="SOLICITAÇÕES FINALIZADAS"
          header-bg-variant="success"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>
              {{ itemsFiltered.filter((s) => s.status === "ATENDIDA").length }}
            </h2>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col cols="3" class="mt-3">
        <b-card
          class="ml-2"
          style="width: 33rem"
          border-variant="primary"
          header="TOTAL SOLICITAÇÕES "
          header-bg-variant="primary"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>
              {{ itemsFiltered.length }}
            </h2>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>
    <!--tbl de dados -->
    <b-table
      id="resolicitante"
      small
      hover
      striped
      sticky-header="756px"
      :items="itemsFiltered"
      :fields="fields"
    >
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          @click="
            loadCarregaSac(data.item),
              loadSacSolicitacoesTratativas(),
              loadStatus(),
              loadResposta()
          "
          title="Acessar solicitação"
          size="sm"
          variant="primary"
          class="mr-2 mt-2"
          v-b-modal.modal-multi-1
        >
          <i class="fa fa-exclamation-circle"></i>
        </b-button>
      </template>
    </b-table>

    <!--  MODAL SOLICITÇÕES  -->
    <div>
      <b-modal
        id="modal-multi-1"
        cancel-title="Fechar"
        ok-title="Gravar"
        @ok.prevent="postSac(), postSacTratativa(), postNotificacao()"
        size="xl"
        :title="`Solicitação Nº.: ${
          sacsolicitacao.id_solicitacao != null
            ? sacsolicitacao.id_solicitacao
            : '-'
        }`"
        no-close-on-esc
        no-close-on-backdrop
      >
        <!-- -->
        <div>
          <b-row>
            <input
              id="id-sac"
              type="hidden"
              v-model="sacsolicitacao.id_solicitacao"
            />

            <b-col cols="1" class="mt-2 pr-4">
              <b-form-group label="" label-for="tabela-foto">
                <b-img
                  height="120"
                  width="78"
                  class="mb-5"
                  v-model="sacsolicitacao.foto_url"
                  v-bind="mainProps"
                  rounded
                  alt="Foto"
                  :src="sacsolicitacao.foto_url"
                >
                </b-img>
              </b-form-group>
            </b-col>

            <b-col cols="2" class="mt-5">
              <label for="input-live">Registro</label>
              <b-form-input
                id="resolicitante"
                v-model="sacsolicitacao.re_solicitante"
                readonly
                placeholder=""
                class="mb-3"
              ></b-form-input>
            </b-col>

            <b-col cols="3" class="mt-5">
              <label for="input-live">Nome</label>
              <b-form-input
                id="resolicitante"
                v-model="sacsolicitacao.nome"
                readonly
                placeholder=""
                class="mb-3"
              ></b-form-input>
            </b-col>

            <b-col cols="3" class="mt-5">
              <label for="input-live">Função</label>
              <b-form-input
                id="resolicitante"
                v-model="sacsolicitacao.funcao_solicitante"
                readonly
                placeholder=""
              ></b-form-input>
            </b-col>

            <b-col sm="3" class="mt-5">
              <label for="input-resolicitante">Parecer</label>
              <div>
                <b-form-select
                  id="resolicitante"
                  v-model="sacsolicitacao.id_status"
                  :options="statuss"
                  class="mb-3"
                  text-field="status"
                >
                </b-form-select>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <label for="textarea-small">Justificativa</label>
            </b-col>
            <b-col sm="12">
              <b-form-textarea
                id="id-pecas"
                v-model="sacsolicitacao.justificativa"
                readonly
                size="sm"
                class="mb-3"
                placeholder="Pergunta do colaborador"
              ></b-form-textarea>
            </b-col>
          </b-row>

          <!-- Tratativas -->
          <div class="d-flex justify-content-center mb-3">
            <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
          </div>
          <!--tbl de dados -->
          <b-table
            id="resolicitante"
            small
            hover
            striped
            sticky-header="330px"
            :items="sacsolicitacoestratativa"
            :fields="tratativas"
          >
          </b-table>

          <b-row>
            <b-col cols="12" class="mt-5">
              <label for="input-resolicitante">Resposta padrão</label>
              <div>
                <b-form-select
                  id="resolicitante"
                  v-model="sacResposta.id"
                  :options="sacResposta"
                  class="mb-3"
                  text-field="resposta"
                  value-field="id"
                  @change="atualizarParecer"
                />
              </div>
            </b-col>

            <b-col sm="12">
              <label for="textarea-small">Parecer da solicitação:</label>
            </b-col>
            <b-col sm="12">
              <b-form-textarea
                id="id-obs"
                v-model="sacsolicitacao.parecer"
                size="sm"
                placeholder="Digite o parecer para o colaborador"
                rows="5"
              />
            </b-col>
          </b-row>

          <b-row>
            <b-col class="mb-3 mt-3 ml-5">
              <div>
                <b-img
                  v-if="sacsolicitacao.file === 'true'"
                  :src="sacsolicitacao.file"
                  width="600"
                  height="600"
                ></b-img>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-modal>
    </div>
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment, { now } from "moment";
import { mapState } from "vuex";
import * as XLSX from "xlsx";
//import LoadingModal_atendimento from '../utilitarios/LoadingModal'

export default {
  name: "SacSolicitacao",

  computed: {
    ...mapState(["user"]),

    itemsFiltered() {
      let valores = [];
      valores = this.sacsolicitacoes.filter((item) => {
        return (
          item.re_solicitante.indexOf(this.search) > -1 ||
          item.modulo.indexOf(this.search) > -1 ||
          item.justificativa.indexOf(this.search) > -1
        );
      });
      return valores;
    },
  },

  data: function () {
    return {
      sacResposta: [], // [] lista
      mode: "save",
      carregando: false,
      atualizando: false,
      isLoading: false,
      empresa: {},
      empresas: [], // [] lista
      value_empresa: [], // [this.empresas],
      value_filial: [],
      value_status: [],
      filial: {},
      filiais: [], // [] lista
      //value_filial:[],// [] lista

      status: {},
      statuss: [], // [] lista

      permissoes: [],
      permissao: {},

      sacsolicitacao: {}, // [] lista
      sacsolicitacoes: [], // [] lista
      pedidoferias: [], // implantado 08/07/2023
      sacT: {}, // [] lista
      sacsolicitacoestratativa: [], // [] lista
      search: "",

      value_id_area: "",

      fields: [
        { key: "id_solicitacao", label: "Nº Solicitação", sortable: true },
        { key: "id_filial", label: "Filial", sortable: true },
        { key: "re_solicitante", label: "Solicitante", sortable: true },
        { key: "funcao_solicitante", label: "Função", sortable: true },

        {
          key: "dt_cadastro",
          label: "Data_Abertura_Solicitação",
          sortable: true,
          formatter: (value, key, sacsolicitacoes) => {
            return moment(sacsolicitacoes.dt_cadastro)
              .format("DD/MM/YYYY - HH:mm ")
              .replace("Data inválida", "-");
          },
        },
        {
          key: "dt_finalizada",
          label: "Data_Encerramento",
          sortable: true,
          formatter: (value, key, sacsolicitacoes) => {
            return moment(sacsolicitacoes.dt_finalizada)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        { key: "tempo", label: "Duração", sortable: false },

        { key: "status", label: "Status", sortable: true },

        { key: "area", label: "     Departamento     ", sortable: true },
        { key: "modulo", label: "Tipo_Solicitação", sortable: true },
        { key: "pedido_ferias", label: "Férias", sortable: true },
        /*

                { key: 'dt_informada', label: 'Pedido_de_férias', sortable: true, formatter: (value, key, sacsolicitacoes) => {
                    return moment(sacsolicitacoes.dt_informada).format('MM/YYYY').replace(null,'-') ; }  },   */

        //         { key: 'dt_informada', label: 'Pedido_de_férias', sortable: true },

        { key: "justificativa", label: "Solicitação", sortable: true },
        { key: "re_finalizado", label: "Encerrado_Por", sortable: true },
        { key: "parecer", label: "Resposta", sortable: true },
        { key: "actions", label: "Atualizar" },
      ],
      //////// defeitos da corretiva

      tratativas: [
        {
          key: "dt_resposta",
          label: "Data_Resposta",
          sortable: true,
          formatter: (value, key, sacsolicitacoestratativa) => {
            return moment(sacsolicitacoestratativa.dt_resposta)
              .format("DD/MM/YYYY - HH:mm ")
              .replace("Data inválida", "-");
          },
        },
        { key: "respondido", label: "Resposta", sortable: true },
        { key: "registro", label: "Registro", sortable: true },
        { key: "justificativa", label: "Justificativa", sortable: true },
        { key: "status", label: "Status", sortable: true },
      ],
    };
  },

  components: {
    Multiselect, //,LoadingModal_atendimento
  },
  methods: {
    atualizarParecer(idSelecionado) {
      const respostaSelecionada = this.sacResposta.find(
        (item) => item.id === idSelecionado
      );
      if (respostaSelecionada) {
        this.sacsolicitacao.parecer = respostaSelecionada.resposta;
      }
    },

    loadResposta() {
      let params = {
        id_grupo: `${this.user.id_grupo}`,
        empresa_id: `${this.user.id_empresa}`,
        //psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };
      const url = `${baseApiUrl}/sac/resposta`;
      axios.get(url, { params }).then((res) => {
        this.sacResposta = res.data.map((resp) => {
          return { ...resp, value: resp.id, resposta: resp.resposta };
        });
      });
    },

    loadEmpresas() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios.get(url, { params }).then((res) => {
        this.empresas = res.data.map((empresa) => {
          return {
            id_empresa: empresa.id_empresa,
            empresa: empresa.nomeempresarial,
          };
        });
      });
    },

    loadFiliais() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa:
          this.value_empresa.length > 0
            ? this.value_empresa.map((e) => e.id_empresa).join(",")
            : this.user.id_empresa, // Verifica se há empresas e junta os ids como string
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };
      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios.get(url, { params }).then((res) => {
        this.filiais = res.data.map((filial) => {
          return { id_filial_erp: filial.id_filial_erp, filial: filial.filial };
        });
      });
    },

    loadStatus() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };
      const url = `${baseApiUrl}/sac/status`;
      axios.get(url, { params }).then((res) => {
        this.statuss = res.data.map((sta) => {
          return { ...sta, value: sta.id_status, status: sta.status };
        });
      });
    },

    loadPermissao() {
      let params = {
        id_grupo: `${this.user.id_grupo}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };

      const url = `${baseApiUrl}/sac/permissao`;
      axios.get(url, { params }).then((res) => {
        this.permissoes = res.data.map((permissao) => {
          return { ...permissao, id_area: permissao.id_area };
        });
        this.loadSacSolicitacoes();
      });
    },

    async loadSacSolicitacoes() {
      //  this.isLoading = true; // Ativa o indicador de carregamento
      let params = {
        id_empresa:
          this.value_empresa.length > 0
            ? `${[this.value_empresa.map((e) => e.id_empresa)]}`
            : `${[this.user.id_empresa]}`,
        id_filial: `${[this.value_filial.map((a) => a.id_filial_erp)]}`,
        id_status: `${[this.value_status.map((r) => r.id_status)]}`,
        id_area: `${[this.permissoes.map((p) => p.id_area)]}`,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };

      const url = await `${baseApiUrl}/sac/solicitacoes`;

      axios
        .get(url, { params })
        .then((res) => {
          this.sacsolicitacoes = res.data.map((sacsolicitacao) => {
            return {
              id_solicitacao: sacsolicitacao.id_solicitacao,
              id_empresa: sacsolicitacao.id_empresa,
              id_filial: sacsolicitacao.id_filial,
              dt_abertura: sacsolicitacao.dt_abertura,
              dt_inclusao: sacsolicitacao.dt_inclusao,
              dt_cadastro: sacsolicitacao.dt_cadastro,
              area: sacsolicitacao.area,
              modulo: sacsolicitacao.modulo,
              id_funcionario_solicitante:
                sacsolicitacao.id_funcionario_solicitante,
              re_solicitante: sacsolicitacao.re_solicitante,
              funcao_solicitante: sacsolicitacao.funcao_solicitante,
              justificativa: sacsolicitacao.justificativa,
              id_status: sacsolicitacao.id_status,
              status: sacsolicitacao.status,
              id_funcionario_analise: sacsolicitacao.id_funcionario_analise,
              re_analisado: sacsolicitacao.re_analisado,
              dt_analise: sacsolicitacao.dt_analise,
              id_funcionario_finalizada:
                sacsolicitacao.id_funcionario_finalizada,
              re_finalizado: sacsolicitacao.re_finalizado,
              dt_finalizada: sacsolicitacao.dt_finalizada,
              parecer: sacsolicitacao.parecer,
              id_leitura: sacsolicitacao.id_leitura,
              leitura: sacsolicitacao.leitura,
              foto_url: sacsolicitacao.foto_url,
              nome: sacsolicitacao.nome,
              tempo: sacsolicitacao.tempo,
              pedido_ferias: sacsolicitacao.pedido_ferias,
            };
          });

          // Verifica se a lista está vazia e exibe uma mensagem
          if (this.sacsolicitacoes.length === 0) {
            alert("Nenhuma solicitação encontrada.");
          }
          this.isLoading = false; // Desativa o indicador de carregamento
        })
        .catch((error) => {
          this.isLoading = false; // Desativa o indicador de carregamento
          if (error.response && error.response.status === 400) {
            // Exibe uma mensagem específica para erro 400
            this.isLoading = false; // Desativa o indicador de carregamento
            // alert('Erro 400: Solicitação inválida. Verifique os dados e tente novamente.');
          } else {
            // Exibe uma mensagem genérica para outros erros
            this.isLoading = false; // Desativa o indicador de carregamento
            //  alert('Ocorreu um erro ao processar a solicitação. Por favor, tente novamente.');
          }
          this.isLoading = false; // Desativa o indicador de carregamento
          console.error("Erro:", error); // Exibe detalhes do erro no console para depuração
        });
    },

    loadPedidoFerias() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };

      const url = `${baseApiUrl}/sac/ferias`;
      axios.get(url, { params }).then((res) => {
        this.carregando = false;
        this.pedidoferias = res.data.map((pedidoferia) => {
          return {
            id_empresa: pedidoferia.id_empresa,
            id_empresa_erp: pedidoferia.id_empresa_erp,
            id_filial: pedidoferia.id_filial,
            id_solicitacao: pedidoferia.id_solicitacao,
            re_solicitante: pedidoferia.re_solicitante,
            pedido_ferias: pedidoferia.pedido_ferias,
            dt_solicitacao: pedidoferia.dt_solicitacao,
            dt_finalizada: pedidoferia.dt_finalizada,
          };
        });
        this.gerarPlanilha();
      });
    },

    gerarPlanilha() {
      // Objeto com os dados para a planilha
      const dados = this.pedidoferias;

      // Cria uma nova planilha
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(dados);

      // Adiciona a planilha ao workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Dados");

      // Salva o workbook como arquivo
      XLSX.writeFile(workbook, "pedido_de_ferias.xlsx");
    },

    loadSacSolicitacoesTratativas() {
      let params = {
        id_solicitacao: `${[this.sacsolicitacao.id_solicitacao]}`,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };

      const url = `${baseApiUrl}/sac/solicitacoes/id`;
      axios.get(url, { params }).then((res) => {
        this.carregando = false;
        this.sacsolicitacoestratativa = res.data.map((sacT) => {
          return {
            id_solicitacao: sacT.id_solicitacao,
            dt_resposta: sacT.dt_resposta,
            id_respondido: sacT.id_respondido,
            respondido: sacT.respondido,
            registro: sacT.registro,
            justificativa: sacT.justificativa,
            id_status_leitura: sacT.id_status_leitura,
            status: sacT.status,
          };
        });
      });
    },

    loadCarregaSac(sacsolicitacao) {
      this.sacsolicitacao = { ...sacsolicitacao };
    },
    loadCarregaSacT(sacsolicitacoestratativa) {
      this.sacsolicitacoestratativa = { ...sacsolicitacoestratativa };
    },

    postSac() {
      let corpo = {
        id_funcionario: `${this.user.id_funcionario}`,
        parecer: `${this.sacsolicitacao.parecer}`,
        id_solicitacao: `${this.sacsolicitacao.id_solicitacao}`,
        id_status: `${this.sacsolicitacao.id_status}`,
        status: `${[
          this.statuss
            .filter((a) => a.id_status == this.sacsolicitacao.id_status)
            .map((a) => a.status),
        ]}`,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };

      const url = `${baseApiUrl}/sac/solicitacoes/save`;

      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.loadSacSolicitacoes();
          //this.reset() limpar os objetos valores
        })
        .catch(showError);
    },

    async postSacTratativa() {
      let corpo = {
        id_solicitacao: `${this.sacsolicitacao.id_solicitacao}`,
        id_funcionario_resposta: `${this.user.id_funcionario}`,
        justificativa: `${this.sacsolicitacao.parecer}`,
        respondido_por: 2,
        id_status_leitura: 1,
        //psg: this.user.id_empresa == 2 ? "teste" : this.user.psg,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };

      const url = `${baseApiUrl}/sac/solicitacoes/save/resposta`;

      try {
        await axios.post(url, corpo);
        this.loadSacSolicitacoesTratativas();

        // Limpar o campo parecer após sucesso
        this.sacsolicitacao.parecer = "";

        this.$bvToast.toast("Dados gravados com sucesso!", {
          title: "Sucesso",
          variant: "success",
          solid: true,
        });
      } catch (error) {
        showError(error);
        this.$bvToast.toast("Erro ao gravar dados", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
      }
    },

    reset() {
      this.parecer = "";
      this.sacsolicitacao.parecer = "";
    },

    putSacTratativa() {
      let corpo = {
        id_solicitacao: `${this.sacsolicitacao.id_solicitacao}`,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };
      const url = `${baseApiUrl}/sac/solicitacoes/put/resposta`;

      axios
        .post(url, corpo)
        .then(() => {
          //this.$toasted.global.defaultSuccess()
          //this.loadSacSolicitacoesTratativas()
          //this.reset()  //limpar os objetos valores
        })
        .catch(showError);
    },

    postNotificacao() {
      let corpo = {
        id_funcionario: `${this.sacsolicitacao.id_funcionario_solicitante}`,
        message:
          "Existe uma nova tratativa para sua solicitação nº " +
          `${this.sacsolicitacao.id_solicitacao}`,
        dt_notificacao: now().toString,
        type: 1,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };

      const url = `${baseApiUrl}/sac/solicitacoes/notificacoes`;

      axios
        .post(url, corpo)
        .then(() => {
          //this.$toasted.global.defaultSuccess()
          // this.loadSacSolicitacoesTratativas()
          //this.reset() limpar os objetos valores
        })
        .catch(showError);
    },

    limparFiltro() {
      this.search = "";
    },
  },

  created() {
    this.loadPermissao();
  },

  mounted() {
    this.loadEmpresas();
    this.loadFiliais();
    this.loadStatus();
    this.loadPermissao();
    this.loadSacSolicitacoes();
    this.loadCarregaSac();
    this.loadCarregaSacT();
    //this.loadSacSolicitacoesTratativas() desabilitei em 20/08/2023 as 20:43h
    //this.loadGaragens()
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#selecaostatusx {
  font-size: 0.9em;
}

#re-nome {
  font-size: 0.9em;
}

#funcao {
  font-size: 0.9em;
}

#re-solicitante {
  font-size: 0.9em;
  font-style: inherit;
}

#parecer {
  font-size: 0.9em;
}

#rfilancamentos {
  font-size: 0.9em;
  text-align: center;
}

#resolicitante {
  font-size: 14px; /* Ajuste o tamanho da fonte conforme necessário */
}
</style>